// Formats an ISO date string (or Date) to a YYYY-MM-DD string for date inputs.
export const formatDate = (date) => {
  if (!date) return ''
  return new Date(date).toISOString().split('T')[0]
}

// Validates that registration / play dates are in the correct chronological order.
export const validateDates = ({
  registration_start,
  registration_end,
  play_start,
  play_end,
}) => {
  const errors = {}
  const dates = {
    registration_start: new Date(registration_start),
    registration_end: new Date(registration_end),
    play_start: new Date(play_start),
    play_end: new Date(play_end),
  }

  if (dates.registration_end <= dates.registration_start) {
    errors.registration_end =
      'Registration end must be after registration start'
  }
  if (dates.play_start <= dates.registration_end) {
    errors.play_start = 'Play start must be after registration end'
  }
  if (dates.play_end <= dates.play_start) {
    errors.play_end = 'Play end must be after play start'
  }

  return errors
}

export const toCreatePayload = (formData) => {
  return {
    ...toBasePayload(formData),
    league_status: formData.league_status,
    allowed_skill_levels: formData.allowed_skill_levels,
  }
}

export const toUpdatePayload = (formData) => {
  return toBasePayload(formData)
}

const toBasePayload = (formData) => {
  return {
    name: formData.name,
    league_type: formData.league_type,
    rules: formData.rules,
    entry_fee:
      formData.entry_fee === '' ? null : parseFloat(formData.entry_fee),
    season: formData.season,
    play_start: formData.play_start
      ? new Date(formData.play_start).toISOString()
      : null,
    play_end: formData.play_end
      ? new Date(formData.play_end).toISOString()
      : null,
    registration_start: formData.registration_start
      ? new Date(formData.registration_start).toISOString()
      : null,
    registration_end: formData.registration_end
      ? new Date(formData.registration_end).toISOString()
      : null,
    age_category: formData.age_category,
    gender: formData.gender,
    region_id: formData.region_id === '' ? null : parseInt(formData.region_id),
    timezone: formData.timezone,
    match_format: formData.match_format,
    playoff_min_matches_required:
      formData.playoff_min_matches_required === ''
        ? 3
        : parseInt(formData.playoff_min_matches_required),
    min_players_per_division:
      formData.min_players_per_division === ''
        ? null
        : parseInt(formData.min_players_per_division),
    max_players_per_division:
      formData.max_players_per_division === ''
        ? null
        : parseInt(formData.max_players_per_division),
    max_registrations:
      formData.max_registrations === ''
        ? null
        : parseInt(formData.max_registrations),
    public_visible: formData.public_visible,
    banner_url: formData.banner_url,
  }
}

export const validateLeagueForm = ({ formData, isEditMode }) => {
  const errors = {}

  if (!formData.name) errors.name = 'League name is required'
  if (!formData.league_type) errors.league_type = 'League type is required'
  if (!formData.age_category) errors.age_category = 'Age category is required'
  if (!formData.season) errors.season = 'Season is required'
  if (!formData.registration_start)
    errors.registration_start = 'Registration start date is required'
  if (!formData.registration_end)
    errors.registration_end = 'Registration end date is required'
  if (!formData.play_start) errors.play_start = 'Play start date is required'
  if (!formData.play_end) errors.play_end = 'Play end date is required'
  if (!isEditMode && formData.allowed_skill_levels.length === 0) {
    errors.allowed_skill_levels = 'Select at least one allowed skill level'
  }

  return {
    ...errors,
    ...validateDates({
      registration_start: formData.registration_start,
      registration_end: formData.registration_end,
      play_start: formData.play_start,
      play_end: formData.play_end,
    }),
  }
}
